module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withSelect) ? _c('v-select', _vm._b({
    ref: "spacePicker",
    attrs: {
      "dense": "",
      "clearable": "",
      "label": _vm.label,
      "items": _vm.spaces,
      "multiple": _vm.multiple,
      "value-comparator": _vm.compare,
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "item-text": "title",
      "item-value": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', [_c('v-avatar', {
          staticClass: "mr-1 elevation-4",
          attrs: {
            "size": 28,
            "color": "gray",
            "color": item.color
          }
        }, [(item.logo_picture) ? _c('v-img', {
          attrs: {
            "src": item.logo_picture
          }
        }) : _vm._e()], 1), _vm._v("\n        " + _vm._s(item.title) + "\n      ")], 1)]
      }
    }, {
      key: "item",
      fn: function(props) {
        return [_c('v-list-tile-action', [_c('v-avatar', {
          attrs: {
            "size": 28,
            "color": props.item.color
          }
        }, [(props.item.logo_picture) ? _c('v-img', {
          attrs: {
            "src": props.item.logo_picture
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            # " + _vm._s(props.item.id) + ":\n            " + _vm._s(props.item.title) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.isSelected(props.item)) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1)]
      }
    }, {
      key: "append-item",
      fn: function() {
        return [_c('v-divider', {
          staticClass: "mb-2"
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "text": "",
            "flat": "",
            "small": "",
            "block": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.spacePicker.blur()
            }
          }
        }, [_vm._v("Done")])]
      },
      proxy: true
    }], null, false, 2158007421),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, 'v-select', _vm.attrs, false)) : _c('v-card', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": "",
      "flat": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.spaces), function(space, index) {
    return _c('v-flex', {
      key: ((space.id) + "-" + index)
    }, [_c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', {
      key: space.id,
      class: {
        "grey--text": !_vm.canEditSpace(space)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSpace(space)
        }
      }
    }, [(_vm.readOnly) ? _c('v-list-tile-action', [(_vm.isSelected(space)) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1) : _c('v-list-tile-action', [(_vm.isSelected(space)) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(space.title))])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-avatar', {
      staticClass: "mr-1 elevation-4",
      attrs: {
        "size": 28,
        "color": space.color,
        "dark": ""
      }
    }, [(space.logo_picture) ? _c('v-img', {
      attrs: {
        "src": space.logo_picture
      }
    }) : (space.title) ? _c('span', {
      domProps: {
        "textContent": _vm._s(space.title[0])
      }
    }) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), 1), _vm._v(" "), (_vm.required && !_vm.readOnly) ? _c('div', {
    staticClass: "caption info--text ml-3 mt-1"
  }, [_vm._v("\n      * required: at least one space must be selected\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf3c0db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/SpacePicker.vue
// module id = 1396
// module chunks = 9